export default __webpack_public_path__ + "static/media/icon_bot_atualizado.6f36cbdc.svg";